import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
    MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatFormFieldModule, MatGridListModule, MatIconModule, MatInputModule,
    MatPaginatorModule, MatRadioModule,
    MatSelectModule, MatTableModule
} from '@angular/material'
import { RouterModule } from '@angular/router'
import { TableAtylDisplayModule } from '../form-table-atyl-display/table-atyl-display.module'
import { SubFormAtylInputComponent } from './sub-form-atyl-input.component'
@NgModule({
    imports: [CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        MatCardModule,
        MatGridListModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatRadioModule,
        MatSelectModule,
        MatTableModule,
        MatAutocompleteModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatPaginatorModule,
        MatExpansionModule,
        TableAtylDisplayModule],
    declarations: [SubFormAtylInputComponent],
    exports: [SubFormAtylInputComponent]
})
export class SubFormAtylInputModule { }